// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__JBhRb","paginationButton":"Pagination_paginationButton__2WIIV","paginationButtonActive":"Pagination_paginationButtonActive__zBMo-"};